import { PrismicRichText } from "@prismicio/react";

import { georgetownRichTextComponents } from "./rich-text";

import type { RichTextField } from "@prismicio/client";

/**
 * Renders a heading rich text field. Headings always carry a `.heading-N` class
 * (matching their tag by default). When `display` (h1/h2/h3) is set, the heading
 * takes on that visual size via `.heading-{display}` regardless of its tag.
 */
export default function Heading({
  field,
  display,
}: {
  field: RichTextField;
  display?: string | null;
}) {
  return (
    <PrismicRichText
      field={field}
      components={georgetownRichTextComponents(display)}
    />
  );
}
